<template>
    <div class="project-single">
        <div class="m-content">
            <div class="row">
                <div class="col-lg-12">
                    <!--begin::Portlet-->
                    <div class="m-portlet m-portlet--accent m-portlet--head-solid-bg m-portlet--head-sm" m-portlet="true" id="m_portlet_tools_1">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
												<span class="m-portlet__head-icon">
													<i class="flaticon-placeholder-2"></i>
												</span>
                                    <h3 class="m-portlet__head-text">
                                        Action Toolsxx
                                    </h3>
                                </div>
                            </div>
                            <div class="m-portlet__head-tools">
                                <ul class="m-portlet__nav">
                                    <li class="m-portlet__nav-item">
                                        <a href="#" m-portlet-tool="toggle" class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-angle-down"></i></a>
                                    </li>
                                    <li class="m-portlet__nav-item">
                                        <a href="#" m-portlet-tool="reload" class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-refresh"></i></a>
                                    </li>
                                    <li class="m-portlet__nav-item">
                                        <a href="#" m-portlet-tool="fullscreen" class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-expand"></i></a>
                                    </li>
                                    <li class="m-portlet__nav-item">
                                        <a href="#" m-portlet-tool="remove" class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-close"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <div class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-height="300" style="overflow:hidden; height: 300px">

                            </div>
                        </div>
                        <div class="m-portlet__foot">
                            <button type="submit" class="btn btn-primary">Submit</button>
                            <span class="m--margin-left-10">or <a href="#" class="m-link m--font-bold">Cancel</a></span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'project-single',
        props: {

        },
        data() {
            return {

            }
        },
        mounted() {

        },
        watch: {

        },
        methods: {

        }
    }
</script>
